import { useEffect } from 'react';

import { notification } from 'antd';
import { isMobileOnly } from 'react-device-detect';
import _ from 'lodash';

/**
 * When export returns a background task, global/export stores the message in global.scheduledTask.
 * Mirrors access-log / users: notify and clear the flag so it does not repeat.
 */
export function useScheduledExportNotification(scheduledTask, dispatch) {
  useEffect(() => {
    if (!scheduledTask) return;
    const [message, description] = _.split(scheduledTask, '.');
    notification.destroy();
    notification.success({
      ...(message && { message }),
      ...(description && { description }),
      ...(!isMobileOnly && { className: 'ace-export-notice' }),
      style: { minWidth: 600 },
      duration: 10,
    });
    dispatch({ type: 'global/cleanup', payload: 'export' });
  }, [scheduledTask, dispatch]);
}

export default useScheduledExportNotification;
